export const SHOPIFY_DOMAIN = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN;

export const STORE_FRONT_ACCESS_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESSTOKEN;

export const PRODUCT_PLATFORM_ID = "7878623756487";

export const PRODUCT_PLATFORM_ID_DELIVERY_COMMITMENT = "8218652410055";

export const GEN_1_MACHINE_PRODUCT_ID = "2029008945201";

export const GEN_1_MACHINE_PRODUCT_VARIANT_ID = "15685587206193";

export const DUET_MACHINE_PRODUCT_ID = "7535183757511";

export const DUET_MACHINE_PRODUCT_VARIANT_ID = "42837907636423";

export const MACHINE_DISCOUNT_MAP = {
  6: 50,
  12: 100,
  18: 150,
  24: 200,
};
